import {
  UNDEFINED_STATUS
} from './action-status';

import {
  HIDE_ALL_VIEW
} from './active-shared-view';

import {
  UNKNOWN
} from './app-type';

import {
  UNKNOWN_LINK_TYPE
} from './link-type';

export default function initialState() {
  return {
    moduleName: 'shared-link',
    linkCipher: '',
    activeSharedView: HIDE_ALL_VIEW,
    appType: UNKNOWN,
    linkType: UNKNOWN_LINK_TYPE,
    linkDetails: {},
    fetchLinkDetailsStatus: UNDEFINED_STATUS,
    linkPassword: '',
    setupLinkPasswordStatus: UNDEFINED_STATUS,
    linkRestoreInfo: '',
    fetchLinkRestoreInfoStatus: UNDEFINED_STATUS,
    linkContentItems: [],
    fetchLinkContentItemsStatus: UNDEFINED_STATUS,
    rootFolderName: '',
    atiBrandName: 'Acronis True Image',
    cbBrandName: 'Acronis Cyber Backup'
  };
}
